import React from 'react';
import { SideMenuProps } from './types';
import {
  StyledSideMenu,
  StyledSideMenuIconWrapper,
  StyledSideMenuLabel,
  StyledSideMenuLink,
  StyledSideMenuList,
  StyledSideMenuListItem,
  StyledSideMenuRow,
} from './styles';

const SideMenu: React.FC<SideMenuProps> = ({
  items,
  additionalItems,
  collapsed,
}) => (
  <StyledSideMenu>
    <StyledSideMenuRow>
      <StyledSideMenuList hasMinHeight>
        {items.map(({ label, to, icon: Icon, key, isActive }) => (
          <StyledSideMenuListItem {...{ key }}>
            <StyledSideMenuLink
              {...{ to, isActive }}
              collapsed={collapsed}
              title={typeof label === 'string' ? label : undefined}
            >
              {Icon && (
                <StyledSideMenuIconWrapper collapsed={collapsed}>
                  <Icon />
                </StyledSideMenuIconWrapper>
              )}
              {!collapsed && <StyledSideMenuLabel>{label}</StyledSideMenuLabel>}
            </StyledSideMenuLink>
          </StyledSideMenuListItem>
        ))}
      </StyledSideMenuList>
    </StyledSideMenuRow>
    {additionalItems && (
      <StyledSideMenuRow>
        <StyledSideMenuList>
          {additionalItems.map(({ label, to, icon: Icon, key }) => (
            <StyledSideMenuListItem {...{ key }}>
              <StyledSideMenuLink
                {...{ to }}
                collapsed={collapsed}
                title={typeof label === 'string' ? label : undefined}
              >
                {Icon && (
                  <StyledSideMenuIconWrapper collapsed={collapsed}>
                    <Icon />
                  </StyledSideMenuIconWrapper>
                )}
                {!collapsed && (
                  <StyledSideMenuLabel>{label}</StyledSideMenuLabel>
                )}
              </StyledSideMenuLink>
            </StyledSideMenuListItem>
          ))}
        </StyledSideMenuList>
      </StyledSideMenuRow>
    )}
  </StyledSideMenu>
);

export default SideMenu;
